import { X } from 'lucide-react';
import { UserActivityPanel } from './UserActivityPanel';

interface Props {
  userIdentifier: string;
  displayName: string;
  date: string | null;
  timeframe: string;
  onClose: () => void;
}

export function UserActivityDetailModal({ userIdentifier, displayName, date, timeframe, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-lg border border-border bg-background p-5" onClick={(e) => e.stopPropagation()}>
        <div className="mb-3 flex items-start justify-between">
          <h3 className="text-lg font-semibold">{displayName}</h3>
          <button type="button" onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X className="h-5 w-5" />
          </button>
        </div>
        <UserActivityPanel userIdentifier={userIdentifier} initialDate={date} initialTimeframe={timeframe} />
      </div>
    </div>
  );
}
